import { GlobalError } from './global-error.component';

export default GlobalError;
